; (function (window, $, undefined) {
    inovestor = window.inovestor || {};
    inovestor.ms = inovestor.ms || {};
    inovestor.ms.web = inovestor.ms.web || {};
    inovestor.ms.web.config = inovestor.ms.web.config || {};

    inovestor.ms.web.storageManager = new (function () {
        var storage = window.sessionStorage;

        var manager = {
            getItem: getItem,
            removeItem: removeItem,
            setItem: setItem
        };

        return manager;

        function getItem(key) {
            var dateTimeReviver = function (key, value) {
                if (typeof value === 'string') {
                    var regexValues = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)(Z|([+\-])(\d{2}):(\d{2}))$/.exec(value);
                    if (regexValues) {
                        // JSON.stringify converts dates to UTC so parse them back
                        return new Date(Date.UTC(+regexValues[1], +regexValues[2] - 1, +regexValues[3], +regexValues[4], +regexValues[5], +regexValues[6]));
                    }
                }
                return value;
            };
            var value = storage.getItem(JSON.stringify(key));

            return JSON.parse(value, dateTimeReviver);
        }

        function removeItem(key) {
            storage.removeItem(JSON.stringify(key));
        }

        function setItem(key, value) {
            storage.setItem(JSON.stringify(key), JSON.stringify(value));
        }
    })();

    inovestor.ms.web.tokenManager = new (function () {
        var storageKey = 'authInfo';

        var manager = {
            getTokens: getTokens,
            setTokens: setTokens,
            refreshTokensAsync: refreshTokensAsync
        };

        return manager;

        function getTokens() {
            return inovestor.ms.web.storageManager.getItem(storageKey);
        }

        function setTokens(accessToken, refreshToken, identityToken) {
            var tokens = {
                accessToken: accessToken,
                refreshToken: refreshToken,
                identityToken: identityToken
            };

            inovestor.ms.web.storageManager.setItem(storageKey, tokens);
        }

        function refreshTokensAsync(refreshTokenEndpoint) {
            var deferred = $.Deferred();
            var currentTokens = inovestor.ms.web.tokenManager.getTokens();

            if (currentTokens && currentTokens.refreshToken) {
                $.get(refreshTokenEndpoint, { refreshToken: currentTokens.refreshToken })
                     .done(function (data) {
                         if (data && data.accessToken && data.refreshToken) {
                             inovestor.ms.web.tokenManager.setTokens(data.accessToken, data.refreshToken, currentTokens.identityToken);
                             deferred.resolve(data.accessToken);
                         } else {
                             deferred.reject();
                         }
                     })
                    .fail(function () {
                        deferred.reject();
                    });
            } else {
                deferred.reject();
            }

            return deferred.promise();
        }
    })();

    inovestor.ms.web.dataCache = {};

})(window, jQuery);